import { render, staticRenderFns } from "./Billing-Schedule.vue?vue&type=template&id=1890d0c1"
import script from "./Billing-Schedule.vue?vue&type=script&lang=js"
export * from "./Billing-Schedule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports